export default {
  app: {
    urlPrefix: '',
    formUuid: '',
    propertyType: '',
    propertyId: '',
    provisions: [],
    isShowToggle: false,
    versionToPresent: 'V1',
    isDraft: '',
    shownMode: '',
    relatedUuid: '',
    deviceType: ''
  },
  customParams: [
  ],
  hostingElement: {
    width: '',
    minHeight: '',
    maxHeight: ''
  }
  
};
